import Skeleton from "@mui/material/Skeleton";
import {FC} from "react";

const ProfileLoader: FC = () => (
    <>
        <Skeleton/>
        <Skeleton/>
        <Skeleton/>
    </>
)

export  default ProfileLoader
